import { Request,Util } from "@xt/xtbase";
const { XtAxios } = Request;
const {getOrigin} = Util;

const URL = typeof process != "undefined" && process.env?.npm_lifecycle_event?.startsWith("build") ? "http://"+getOrigin("package-inc",{noProtocol:true})+"/seo-management-impl/" : 
  (typeof process != "undefined" && process.env?.NODE_ENV != "production"
    ? "http://app-doc.sigma115.com/data-center/seo-management-impl/"
    : "http://seo-management-impl/");

//获取TDK
export function get_tdk(config) {
  return XtAxios.get(URL + `web`, config);
}
